export default __webpack_public_path__ + "static/media/login_background_img_small_small.9fcac5e8.png";